import * as z from 'zod'
import { dateSchema } from '~/shared/lib/schemas'
import { isString } from '~/shared/lib/utils'
import { ApiModel } from './core'

const schema = z.object({
  type: z.string(),
  previewUrl: z.string(),
  bigUrl: z.string(),
  createdAt: dateSchema,
  updatedAt: dateSchema.optional(),
})

export type DocumentAttributes = z.infer<typeof schema>

export class Document extends ApiModel<typeof schema> {
  static jsonApiType = 'documents'

  static schema = schema

  getType(): string {
    return this.getAttribute('type')
  }

  getPreviewUrl(): string {
    return this.getAttribute('previewUrl')
  }

  getBigUrl(): string {
    return this.getAttribute('bigUrl')
  }

  hasUrls() {
    return isString(this.getPreviewUrl()) && isString(this.getBigUrl())
  }
}
